import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../../../Services/constant";

const initialState = {
    data: null,
    token: "",
    loading: false,
};

export const loginAdmin = createAsyncThunk(
    "/admin/login",
    async (body) => {
        const res = await fetch(API_URL + "/admin/login", {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await res.json();
        return data;
    }
);

export const adminSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            state.token = "";
            state.data = null;
            localStorage.removeItem("access_token");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAdmin.pending, (state) => {
                state.loading = true;
            })
            .addCase(loginAdmin.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.data = payload?.result?.user;
                state.token = payload?.result?.token;
                localStorage.setItem("adminToken", payload?.result?.token)
            })
            .addCase(loginAdmin.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const adminReducer = adminSlice.reducer;
export const { logout } = adminSlice.actions;
